import Dropdown from '../classes/Dropdown';

class DropdownModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.setDropdowns();
    }

    bindUI() {
        this.ui = {};

        this.ui.$dropdowns = document.querySelectorAll('.js-dropdown');
    }

    setDropdowns() {
        this.dropdowns = [];
        if (this.ui.$dropdowns.length) {

            [].forEach.call(this.ui.$dropdowns, (item, index) => {
                this.dropdowns.push(new Dropdown({
                    el: item
                }))
            });
        }
    }

}

export default DropdownModule;